import { AdminQuery } from '../types';
import { api } from '../../../../core/utils/apiClient';

export class AdminQueriesService {
  async getAllQueries(limit: number = 100): Promise<AdminQuery[]> {
    try {
      const response = await api.get(`/api/v1/llm/query/history?limit=${limit}`);
      if (response.ok) {
        return await response.json();
      }
      return [];
    } catch (error) {
      console.error('Error fetching queries:', error);
      return [];
    }
  }

  async getQueryById(queryId: number): Promise<AdminQuery | null> {
    try {
      const response = await api.get(`/api/v1/llm/query/history/${queryId}`);
      if (response.ok) {
        return await response.json();
      }
      return null;
    } catch (error) {
      console.error('Error fetching query:', error);
      return null;
    }
  }

  async getQueryAnalytics() {
    try {
      const response = await api.get('/api/v1/llm/query/analytics');
      if (response.ok) {
        return await response.json();
      }
      return null;
    } catch (error) {
      console.error('Error fetching query analytics:', error);
      return null;
    }
  }
}

export const adminQueriesService = new AdminQueriesService();

